import { ReactNode } from 'react';

import { useConversationLayoutContext } from './ConversationLayoutProvider';
import { Sidebar, SidebarInner } from './conversationLayout.styles';

type Props = {
  children: ReactNode;
};
export const ConversationLayoutSidebar = ({ children }: Props) => {
  const { isSidebarCollapsed } = useConversationLayoutContext();

  return (
    <Sidebar>
      <SidebarInner isCollapsed={isSidebarCollapsed}>{children}</SidebarInner>
    </Sidebar>
  );
};
